const Augl = {
  init(target) {
    const modal = document.querySelector('.modal')

    target.addEventListener('click', () => this.open(target, modal))
    window.addEventListener('resize', () => this.resize(modal))
    window.addEventListener('load', () => this.resize(modal))
  },
  resize(modal) {
    const modalContainer = modal.querySelector('.container') as HTMLElement
    const aspectRatio = 16 / 9
    const windowWidth = window.innerWidth
    const windowHeight = window.innerHeight

    if (windowHeight < windowWidth) {
      const preferredNewWidth = (windowHeight - 180) * aspectRatio
      const newContainerWidth = preferredNewWidth > windowWidth ? windowWidth : preferredNewWidth

      modalContainer.setAttribute('style', `width:${newContainerWidth}px`)
    } else {
      modalContainer.setAttribute('style', 'width:100%')
    }
  },
  open(target, modal) {
    const iframe = modal.querySelector('iframe')
    const videoId = target.getAttribute('data-vidid')
    let videoSrc = iframe.getAttribute('data-src')
    videoSrc = videoSrc.replace('VIDID', videoId)
    iframe.src = videoSrc
    modal.classList.add('modal--open')
  },
}

export default Augl
